<template>
  <button
      class="field-item"
      :class="{'disabled-link': disabled}"
      :disabled="disabled"
      type="button"
      @click="bubbleNativeEvent"
  >
    <slot></slot>
  </button>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },
  },
});
</script>